import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Header({ lastSaved }) {
  const [timeAgo, setTimeAgo] = useState('just now');

  useEffect(() => {
    if (!lastSaved) return;

    const updateTimer = () => {
      const seconds = Math.floor((Date.now() - lastSaved) / 1000);
      if (seconds < 5) setTimeAgo('just now');
      else if (seconds < 60) setTimeAgo(`${seconds}s ago`);
      else setTimeAgo(`${Math.floor(seconds / 60)}m ago`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [lastSaved]);

  return (
    <header className="sticky top-0 bg-offwhite border-b-2 border-black z-50">
      <div className="w-full px-6 py-4 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-4">
          <div className="w-6 h-6 bg-black text-white flex items-center justify-center font-bold text-sm">
            +
          </div>
          <div>
            <h1 className="font-bold text-lg leading-none uppercase tracking-tight">GospelWise Author</h1>
            <p style={{
      fontSize: '11px'
    }} className="text-[10px] font-medium text-gray-500 uppercase tracking-widest mt-1">Cross + Pen Resources</p>
          </div>
        </div>

        <div className="flex items-center gap-6">
          {/* Save Status Notification */}
          <div className="flex items-center gap-2 px-3 py-1 bg-white border border-gray-200 shadow-brutal-sm">
            <SafeIcon icon={FiIcons.FiSave} className="text-orange text-xs" />
            <span style={{
      fontSize: '11px'
    }} className="text-[10px] font-bold uppercase tracking-widest text-gray-500">Last Saved:<span style={{
      fontSize: '11px'
    }} className="text-black">{timeAgo}</span>
            </span>
          </div>

          <div className="hidden sm:flex items-center gap-3">
            <span style={{
      fontSize: '12px'
    }} className="text-[11px] font-bold text-gray-500 uppercase tracking-widest">Write. Refine. Release Cohort</span>
            <div style={{
      fontSize: '12px'
    }} className="text-[11px] font-bold bg-black text-white px-3 py-1.5 uppercase tracking-wider">Module 3: Self-Edit</div>
          </div>
        </div>
      </div>
    </header>
  );
}